import { ArrowRight } from "lucide-react";
import "./signup.css";

export default function SignupSubscriptionNotice({
  needsAttention = true,
}: {
  needsAttention?: boolean;
}) {
  return (
    <section className="signup-pending-note" aria-label="Subscription support">
      <h2>
        {needsAttention
          ? "Your existing subscription needs attention."
          : "Manage your subscription with our team."}
      </h2>
      <p>
        {needsAttention
          ? "Contact support@chekkit.io so we can help restore your account using your existing subscription."
          : "For payment method or subscription changes, contact support@chekkit.io. We’ll help update your existing subscription."}
      </p>
      <a className="sp-button-secondary" href="mailto:support@chekkit.io">
        Get subscription help
        <ArrowRight size={16} />
      </a>
    </section>
  );
}
